import React, { FunctionComponent } from "react";
import styled from "styled-components";

export const Root = styled("div")`
    background-color: ${(props) => props.theme.palette.common.white};
    border: 2px solid #e2e2e2;
    border-radius: 4px;
    display: flex;
    opacity: 0.6;
    width: 100%;
`;

export const StepCardActive = styled(Root)`
    background-color: ${(props) => props.theme.palette.common.white};
    border: 2px solid ${(props) => props.theme.palette.secondary.main};
    opacity: 1;
`;

export const StepCardDone = styled(Root)`
    background-color: ${(props) => props.theme.palette.common.white};
    opacity: 1;
`;

export const IconContainer = styled("div")`
    display: flex;
    justify-content: center;
    margin: 24px 20px;

    ${(props) => props.theme.breakpoints.up("desktop")} {
        margin: 27px 37px;
    }
`;

export const ChildrenContent = styled("div")`
    color: ${(props) => props.theme.palette.grey[100]};
    margin: 24px 23px 24px 0;
    width: 100%;

    ${(props) => props.theme.breakpoints.up("desktop")} {
        margin: 30px 53px 44px 0;
        width: 100%;
    }
`;

const StyledIcon = styled("svg")`
    color: ${(props) => props.theme.palette.grey[40]};
    height: 42px;
    width: 42px;

    ${(props) => props.theme.breakpoints.up("desktop")} {
        height: 50px;
        width: 50px;
    }
`;

const StyledIconActive = styled(StyledIcon)`
    color: #4a4a4a;
`;

const StyledIconDone = styled(StyledIcon)`
    color: ${(props) => props.theme.palette.secondary.main};
`;

export interface StepCardProps {
    active?: boolean;
    className?: string;
    done?: boolean;
    icon?: any;
}

const StepCard: FunctionComponent<StepCardProps> = ({ active, children, className, done, icon }) => {
    if (!done && active) {
        return (
            <StepCardActive className={className}>
                <IconContainer>{icon && <StyledIconActive as={icon} />}</IconContainer>
                <ChildrenContent>{children}</ChildrenContent>
            </StepCardActive>
        );
    }

    if (done) {
        return (
            <StepCardDone className={className}>
                <IconContainer>{icon && <StyledIconDone as={icon} />}</IconContainer>
                <ChildrenContent>{children}</ChildrenContent>
            </StepCardDone>
        );
    }

    return (
        <Root className={className}>
            <IconContainer>{icon && <StyledIcon as={icon} />}</IconContainer>
            <ChildrenContent>{children}</ChildrenContent>
        </Root>
    );
};

export default StepCard;
